var map = {
	"./demos.ts": [
		29836,
		9836
	],
	"./en.ts": [
		90999,
		999
	],
	"./th.ts": [
		19130,
		9130
	],
	"./vi.ts": [
		5179,
		5179
	],
	"./zh-cn.ts": [
		8813,
		8813
	],
	"./zh-tw.ts": [
		86990,
		6990
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 9532;
module.exports = webpackAsyncContext;